/**
 * Formats a MAC address by removing colons and dots, and converting it to uppercase.
 *
 * @param {string} mac_address
 * @returns {string}
 */
export const formatMacAddress = (mac_address: string): string => {
  return (mac_address ?? '').replace(/[:.-]/g, '').toUpperCase();
};
